import { BRAND, CONTACT, WHATSAPP_URL } from "@/constants/site";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative env-white border-t hairline py-14 md:py-16"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-10 border-b hairline">
          <div className="md:col-span-4">
            <img src={BRAND.logoUrl} alt="licito.guru" className="h-10 w-auto" />
            <p className="mt-5 text-[#1A3A61]/65 text-[14px] leading-relaxed max-w-sm">
              Inteligência artificial especializada em licitações e contratos públicos.
            </p>
          </div>

          <div className="md:col-span-2">
            <span className="kicker">Produto</span>
            <ul className="mt-4 space-y-2.5 text-[#1A3A61] text-[14px]">
              <li><a href="/#funcionalidades" className="hover:text-[#2EE59D] transition-colors">Funcionalidades</a></li>
              <li><a href="/#produto" className="hover:text-[#2EE59D] transition-colors">IA Personalizada</a></li>
              <li>
                <a
                  href="https://ai.licito.guru/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#2EE59D] transition-colors"
                >
                  Entrar
                </a>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#2EE59D] transition-colors"
                >
                  Testar grátis
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="kicker">Institucional</span>
            <ul className="mt-4 space-y-2.5 text-[#1A3A61] text-[14px]">
              <li><Link to="/manifesto" className="hover:text-[#2EE59D] transition-colors">Manifesto licito.guru</Link></li>
              <li><Link to="/faca-parte" className="hover:text-[#2EE59D] transition-colors">Faça parte da nossa equipe</Link></li>
              <li><Link to="/lgpd" className="hover:text-[#2EE59D] transition-colors">LGPD</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="kicker">Contato</span>
            <ul className="mt-4 space-y-2.5 text-[#1A3A61] text-[14px]">
              <li><a href="tel:+554198002461" className="hover:text-[#2EE59D] transition-colors">{CONTACT.phone1}</a></li>
              <li><a href="tel:+554832047194" className="hover:text-[#2EE59D] transition-colors">{CONTACT.phone2}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-[#2EE59D] transition-colors">{CONTACT.email}</a></li>
              <li className="pt-2 text-[#1A3A61]/60 text-[13px] leading-relaxed">{CONTACT.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[#1A3A61]/55 text-[12px]">
          <span>© {new Date().getFullYear()} licito.guru · Todos os direitos reservados.</span>
          <span>Inteligência artificial para o setor público · Florianópolis/SC</span>
        </div>
      </div>
    </footer>
  );
}
